<template>
  <div class='InputIconCateg'>
    <button>
      Selecionar ícone
      <component
      :is="SelectedCategEdit.icon"
      :tam="'25px'"
      :count="false"
      />
    </button>
    <input ref="in" v-show="false" type="file" @change="inFile"/>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { icons } from '@/components/icons'
export default {
  name: 'InputIconCateg',
  components: { ...icons },
  emits: ['update:modelValue'],
  computed: {
    ...mapGetters(['SelectedCategEdit'])
  },
  methods: {
    inFile (e) {
      for (let key in e.target.files) {
        if (key !== 'length' && key !== 'item') {
          this.getBase64(e.target.files[key])
        }
      }
    },
    getBase64 (file) {
      let reader = new FileReader()
      reader.readAsDataURL(file)
      reader.onload = () => {
        this.$emit('update:modelValue', reader.result)
        // console.log(reader.result)
      }
      reader.onerror = (error) => {
        console.log('Error: ', error)
      }
    }
  }
}
</script>

<style scoped>
.InputIconCateg {
  margin-top: 15px;
}

button {
  width: 99%;
  padding: 2%;
  border: 0;
  border-radius: 5px;
  background-color: #CCCCCC;
  cursor: pointer;
}
</style>
